//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { deserializeMediaItem } from '@apis/media-library/mediaLibraryApiUtils';
import {
  IMaterializedTweetWithMetrics,
  ITwitterTweet,
} from '@apis/twitter-analytics/twitterAnalyticsApiModel';
import { Serialized } from '@utils/types/Serialized';

export const deserializeTweetsWithMetrics = (
  tweets: Serialized<IMaterializedTweetWithMetrics[]>,
): IMaterializedTweetWithMetrics[] => {
  return tweets.map((tweetWithMetrics) => ({
    ...tweetWithMetrics,
    tweet: tweetWithMetrics.tweet && deserializeTweet(tweetWithMetrics.tweet),
    mediaItem:
      tweetWithMetrics.mediaItem &&
      deserializeMediaItem(tweetWithMetrics.mediaItem),
  }));
};

export const deserializeTweet = (
  tweet: Serialized<ITwitterTweet>,
): ITwitterTweet => ({
  ...tweet,
  geo: {
    ...tweet.geo,
    coordinates: tweet.geo?.coordinates && {
      ...tweet.geo.coordinates,
      coordinates: tweet.geo.coordinates.coordinates as [number, number],
    },
  },
});
